import React from 'react';
import { Alert, Form, Input, Select } from 'antd';
import { CreditCardOutlined, InfoCircleOutlined,NumberOutlined } from '@ant-design/icons';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { InputFormatter } from '../components/InputFormatter';

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if (formPlugin.formData.type !== "COMPLEX") {
                if (props.remove) {
                    props.remove()
                }
                return null
            }

            const codes = formPlugin.formData?.promotionalCodes || []

            if ((props.isPreviewMode || props.readOnly) && codes.length === 0) {
                return null
            }

            if (codes.length === 0) {
                return (
                    <Alert
                        showIcon
                        type={"warning"}
                        message={t`Veuillez Ajouter des Codes Promotionnels.`}
                    />
                )
            }

            const { data } = props

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            const finalName = "__promo"
            return (
                <Form.Item shouldUpdate noStyle>
                    {(form)=>
                    {
                        let input=form.getFieldValue("__promo")

                        let help=null
                        let hasHelp=false

                        if(input?.length>0)
                        {
                            hasHelp=true
                            let code=codes.find(i=>i?.promotionalCode===input)
                            if(code){
                                help=(<span style={{color:"green"}}>{t`-${code.reducedPercent}% de réduction appliquée.`}</span>)
                            }else {
                                help=(<span style={{color:"red"}}>{t`Le code de réduction est introuvable.`}</span>)
                            }
                        }


                        return(
                            <div style={{marginBottom:hasHelp?30:0}}>

                                <Form.Item
                                    label={`${data.label || t`Code de Réduction`} :`}
                                    name={finalName}
                                    tooltip={tooltip}
                                    help={help}
                                >
                                    <InputFormatter
                                        format={(text) => {
                                            return text
                                                ?.normalize("NFD")
                                                .replace(/[\u0300-\u036f]/g, "")
                                                .replace(/[^a-zA-Z0-9\s-]/g, "")
                                                .replace(/\s+/g, "-")
                                                .replace(/-+/g, "-")
                                                .replace(/^-+/, "")
                                                .toUpperCase();
                                        }}
                                    >
                                        <Input placeholder={data.label || t`Code de Réduction`}/>
                                    </InputFormatter>
                                </Form.Item>

                            </div>
                        )
                    }}
                </Form.Item>
            )
        },
        namespace: namespace,
        id: 'form-promo' + namespace,
        title: t`Code de Réduction`,
        description: t`Élément de formulaire utilisable.`,
        icon: <NumberOutlined />,
        iconColor: "#8E44AD",
        hideInMenu: formPlugin.formData.type !== "COMPLEX",
        version: 1,
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },

                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                }
            },
        },
    }
}
